"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
/* eslint-disable @typescript-eslint/comma-dangle */
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const input_1 = require("../../input");
const icon_1 = require("../../icon");
require("./password-input.scss");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const PasswordInput = ({ control, name, label, disabled, error, rules, placeholder, testid, autocomplete, autoFocus, onSubmit }) => {
    const { field, fieldState } = (0, react_hook_form_1.useController)({ control, name, rules });
    const [passwordVisible, setPasswordVisible] = react_1.default.useState(false);
    const toggleVisibility = () => setPasswordVisible(!passwordVisible);
    const type = passwordVisible ? 'text' : 'password';
    // the `error` prop is the caller's own message (a cross-field check it runs itself);
    // `fieldState` is what the `rules` above produced
    const hasError = ((0, util_1.isDefined)(error) && (0, util_1.isNotNull)(error)) || (0, util_1.isDefined)(fieldState.error);
    return react_1.default.createElement("div", { className: 'password-input' },
        react_1.default.createElement(input_1.Input, { type: type, size: "full-width", label: label, placeholder: (0, maybe_unwrap_1.unwrapMaybe)(placeholder), disabled: field.disabled || disabled, autocomplete: autocomplete, autoFocus: autoFocus, 
            // @ts-expect-error
            innerRef: field.ref, value: field.value, onChange: field.onChange, onBlur: field.onBlur, onSubmit: onSubmit, name: field.name, hasError: hasError, errorMessage: (0, maybe_unwrap_1.unwrapMaybe)(error) ?? fieldState.error?.message, testid: testid, extraContent: 
            // mousedown is swallowed so that reaching for the eye does not take the caret out
            // of the box the person is typing in
            react_1.default.createElement("div", { onMouseDown: (e) => e.preventDefault() },
                react_1.default.createElement("div", { style: { display: passwordVisible ? undefined : 'none' } },
                    react_1.default.createElement(icon_1.Icon, { ico: icon_1.Icon.ICONS.hide, color: icon_1.Icon.COLORS.DARK_BLUE, onClick: toggleVisibility })),
                react_1.default.createElement("div", { style: { display: passwordVisible ? 'none' : undefined } },
                    react_1.default.createElement(icon_1.Icon, { ico: icon_1.Icon.ICONS.view, color: icon_1.Icon.COLORS.DARK_BLUE, onClick: toggleVisibility }))) }));
};
exports.PasswordInput = PasswordInput;
